module.exports = __webpack_public_path__ + "media/img/description/galaxy-55771a82b011e817cbad9b67468f4db8.svg";